// extracted by mini-css-extract-plugin
export var quantityInput = "_nt-0";